<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left"
    >
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
                 label-width="80px">
                        <el-row>
                            <el-form-item label="证件号码" prop="zjhm">
                                <el-input v-model="dataForm.zjhm"></el-input>
                            </el-form-item>
                        </el-row>
            <el-row>
                        <el-form-item label="报名职位" prop="bmzw">
                            <el-input v-model="dataForm.bmzw"></el-input>
                        </el-form-item>
            </el-row>
            <el-row type="flex" justify="start">
                <el-col :span="6" >
                    <el-form-item label="姓名" prop="xm">
                        <el-input v-model="dataForm.xm"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" >
                    <el-form-item label="性别" prop="xb">
                        <el-select :disabled="true" clearable filterable v-model="dataForm.xb" placeholder="">
                            <el-option
                                    label="男"
                                    value="1">
                            </el-option>
                            <el-option
                                    label="女"
                                    value="0">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="退伍军人" prop="mz">
                        <!--        <el-input v-model="dataForm.tw"></el-input>-->
                        <el-select clearable filterable v-model="dataForm.tw" placeholder="">
                            <el-option
                                    label="是"
                                    value="是">
                            </el-option>
                            <el-option
                                    label="否"
                                    value="否">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <!--        <el-form-item label="年龄" prop="nl">-->
                <!--            <el-input v-model="dataForm.nl" :disabled="true"></el-input>-->
                <!--        </el-form-item>-->
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="政治面貌" prop="zzmm">
                        <!--        <el-input v-model="dataForm.tw"></el-input>-->
                        <el-select clearable filterable v-model="dataForm.zzmm" placeholder="">
                            <el-option
                                    label="党员"
                                    value="党员">
                            </el-option>
                            <el-option
                                    label="群众"
                                    value="群众">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                    <el-col :span="8">
                        <el-form-item label-width="130px" label="介绍单位或介绍人" prop="jsr">
                            <el-input v-model="dataForm.jsr"></el-input>
                        </el-form-item>
                    </el-col>
                <el-col :span="8">
                    <el-form-item label-width="80px" label="证件地址" prop="zjdz">
                        <el-input v-model="dataForm.zjdz"></el-input>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-form-item label="在沪地址" prop="zhdz">
                    <el-input v-model="dataForm.zhdz"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="出生日期" prop="csrq">
                        <el-input v-model="dataForm.csrq" :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="民族" prop="mz">
                        <el-input v-model="dataForm.mz"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="是否残疾" prop="cj">
                        <!--        <el-input v-model="dataForm.cj"></el-input>-->
                        <el-select clearable filterable v-model="dataForm.cj" placeholder="">
                            <el-option
                                    label="是"
                                    value="是">
                            </el-option>
                            <el-option
                                    label="否"
                                    value="否">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="身高" prop="sg">
                        <el-input v-model="dataForm.sg"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="体重(公斤)" prop="tz">
                        <el-input v-model="dataForm.tz"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="手机号码" prop="sjhm">
                        <el-input v-model="dataForm.sjhm"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="街道" prop="jd">
                        <el-input v-model="dataForm.jd"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="腰围" prop="yw">
                        <el-input v-model="dataForm.yw"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="鞋码" prop="xiema">
                        <el-input v-model="dataForm.xiema"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="缴金状态" prop="jjzt">
<!--                                                <el-checkbox-group v-model="checkListJjzt">-->
<!--                                                    <el-checkbox label="正常缴金"></el-checkbox>-->
<!--                                                    <el-checkbox label="协保缴金"></el-checkbox>-->
<!--                                                    <el-checkbox label="提前退休"></el-checkbox>-->
<!--                                                    <el-checkbox label="适龄退休"></el-checkbox>-->
<!--                                                </el-checkbox-group>-->
<!--                        <el-checkbox-group v-model="dataForm.jjzt">-->
<!--                            <el-checkbox label="正常缴金"></el-checkbox>-->
<!--                            <el-checkbox label="协保缴金"></el-checkbox>-->
<!--                            <el-checkbox label="提前退休"></el-checkbox>-->
<!--                            <el-checkbox label="适龄退休"></el-checkbox>-->
<!--                        </el-checkbox-group>-->
                        <el-radio v-model="dataForm.jjzt" label="正常缴金">正常缴金</el-radio>
                        <el-radio v-model="dataForm.jjzt" label="协保缴金">协保缴金</el-radio>
                        <el-radio v-model="dataForm.jjzt" label="提前退休">提前退休</el-radio>
                        <el-radio v-model="dataForm.jjzt" label="适龄退休">适龄退休</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="个人情况" prop="sg">
<!--                        <el-checkbox-group v-model="dataForm.grqk">-->
<!--                            <el-checkbox label="享受低保待遇"></el-checkbox>-->
<!--                            <el-checkbox label="享受就业困难待遇"></el-checkbox>-->
<!--                        </el-checkbox-group>-->
                        <el-radio v-model="dataForm.grqk" label="提前退休">提前退休</el-radio>
                        <el-radio v-model="dataForm.grqk" label="适龄退休">适龄退休</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label-width="200px" label="连续多少月缴纳灵活就业社保" prop="jysb">
                        <el-input v-model="dataForm.jysb"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label-width="200px" label="连续多少月未缴纳社保" prop="wjnsb">
                        <el-input v-model="dataForm.wjnsb"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="婚姻状况" prop="hyzk">
<!--                        <el-checkbox-group v-model="checkList">-->
<!--                            <el-checkbox label="未婚"></el-checkbox>-->
<!--                            <el-checkbox label="已婚"></el-checkbox>-->
<!--                            <el-checkbox label="丧偶"></el-checkbox>-->
<!--                            <el-checkbox label="离婚"></el-checkbox>-->
<!--                        </el-checkbox-group>-->

                            <el-radio v-model="dataForm.hyzk" label="未婚">未婚</el-radio>
                            <el-radio v-model="dataForm.hyzk" label="已婚">已婚</el-radio>
                            <el-radio v-model="dataForm.hyzk" label="丧偶">丧偶</el-radio>
                            <el-radio v-model="dataForm.hyzk" label="离婚">离婚</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label-width="300px" label="是否曾有拘留记录、犯罪记录或其他违法记录" prop="mz">
                        <!--        <el-input v-model="dataForm.tw"></el-input>-->
                        <el-select clearable filterable v-model="dataForm.fzjl" placeholder="">
                            <el-option
                                    label="是"
                                    value="是">
                            </el-option>
                            <el-option
                                    label="否"
                                    value="否">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label-width="450px" label="是否患有或曾经患有先天性疾病、传染类疾病、精神类疾病或其他疾病" prop="hyjb">
                        <!--        <el-input v-model="dataForm.tw"></el-input>-->
                        <el-select clearable filterable v-model="dataForm.hyjb" placeholder="">
                            <el-option
                                    label="是"
                                    value="是">
                            </el-option>
                            <el-option
                                    label="否"
                                    value="否">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="文化程度" prop="whcd">
                        <!--        <el-input v-model="dataForm.whcd"></el-input>-->

                        <el-select clearable filterable v-model="dataForm.whcd" placeholder="">
                            <el-option
                                    label="初中及以下"
                                    value="初中及以下">
                            </el-option>
                            <el-option
                                    label="高中"
                                    value="高中">
                            </el-option>
                            <el-option
                                    label="大专"
                                    value="大专">
                            </el-option>
                            <el-option
                                    label="本科"
                                    value="本科">
                            </el-option>
                            <el-option
                                    label="研究生及以上"
                                    value="研究生及以上">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="社保停缴日期" label-width="120px" prop="sbtjrq">
                        <!--        <el-input v-model="dataForm.sbtjrq"></el-input>-->
                        <el-date-picker
                                v-model="dataForm.sbtjrq"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="保安上岗证" label-width="120px" prop="basgz">
                        <!--        <el-input v-model="dataForm.basgz"></el-input>-->
                        <el-select clearable filterable v-model="dataForm.basgz" placeholder="">
                            <el-option
                                    label="有"
                                    value="有">
                            </el-option>
                            <el-option
                                    label="无"
                                    value="无">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="消防设施操作员证" label-width="130px" prop="xfssczz">
                        <!--        <el-input v-model="dataForm.xfssczz"></el-input>-->
                        <el-select clearable filterable v-model="dataForm.xfssczz" placeholder="">
                            <el-option
                                    label="无"
                                    value="无">
                            </el-option>
                            <el-option
                                    label="一级"
                                    value="一级">
                            </el-option>
                            <el-option
                                    label="二级"
                                    value="二级">
                            </el-option>
                            <el-option
                                    label="三级"
                                    value="三级">
                            </el-option>
                            <el-option
                                    label="四级"
                                    value="四级">
                            </el-option>
                            <el-option
                                    label="五级"
                                    value="五级">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                    <el-form-item label="满足条件职位" label-width="120px" prop="bmzw">
                        <el-input v-model="dataForm.mztjzw"></el-input>
                    </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="附件" prop="bmzw">
                    <file-upload :value="fileList" @input="fileListChange"></file-upload>
                </el-form-item>
            </el-row>


        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import FileUpload from "@/components/FileUpload/index";

    export default {
        components: {FileUpload},
        data() {
            const validateNumber = (rule, value, callback) => {
                var patrn = /^\d+(\.\d+)?$/;
                if (!patrn.exec(value)) {
                    callback(new Error('请填写数字'))
                } else {
                    callback()
                }
            }
            return {
                form: {
                    name: ''

                },
                equips: [],
                approvers: [],
                loading1: false,
                //表单验证规则
                rules: {
                    name: [{
                        required: true,
                        trigger: 'blur',
                        message: '请输入姓名',
                    }]
                },
                credentials: [],
                loading: false,
                visible: false,
                useridList: [],
                menuList: [],
                customerList: [],
                dataForm: {
                    zjhm: '',
                    xm:'',
                    xb: '',
                    nl: '',
                    bmzw:'',
                    hyzk:[
                        '复选框 A',
                        '复选框 B',
                    ],
                    tw:'',
                    zzmm:'',
                    jsr:'',
                    zjdz:'',
                    zhdz:'',
                    csrq:'',
                    mz:'',
                    cj:'',
                    sg:'',
                    tz:'',
                    sjhm:'',
                    jd:'',
                    yw:'',
                    xiema:'',
                    jjzt:'',
                    grqk:'',
                    jysb:'',
                    wjnsb:'',
                    hyzk:'',
                    fzjl:'',
                    hyjb:'',
                    whcd:'',
                    sbtjrq:'',
                    basgz:'',
                },
                checkListJjzt: [],
                types: [],
                fileList: [],
                fileList2: [],
                dialogVisible: false,
                dialogImageUrl: '',
                currentPage: 1,
                total: 0,
                uploadUrl: '',
                dataListSelections: [],
                dataRule: {
                    xm: [
                        {required: true, message: '请选择用户', trigger: 'blur'}
                    ],
                    xb: [{
                        required: true,
                        trigger: 'blur',
                        message: '请选择类型',
                    }],
                    zjhm: [
                        // { required: false, trigger: 'blur', validator: cardIdNo }
                        // { required: true,message: "证件号码不能为空",trigger: 'blur'}
                        {required: true, validator: this.cardIdNo, trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            fileListChange(fileList) {
                debugger
                this.fileList = fileList
            },
            async cardIdNo(rule, value, callback) {
                // if (value) {
                //     let reg = /((^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$))/;
                //     if (!reg.test(value)) {
                //         callback(new Error('请输入正确格式的身份证号'));
                //     } else {
                //         await this.go(value.length)
                //         callback();
                //     }
                // } else {
                //     callback(new Error('身份证号不能为空'));
                //     // callback();
                // }

                let city = {
                    11: '北京',
                    12: '天津',
                    13: '河北',
                    14: '山西',
                    15: '内蒙古',
                    21: '辽宁',
                    22: '吉林',
                    23: '黑龙江',
                    31: '上海',
                    32: '江苏',
                    33: '浙江',
                    34: '安徽',
                    35: '福建',
                    36: '江西',
                    37: '山东',
                    41: '河南',
                    42: '湖北',
                    43: '湖南',
                    44: '广东',
                    45: '广西',
                    46: '海南',
                    50: '重庆',
                    51: '四川',
                    52: '贵州',
                    53: '云南',
                    54: '西藏',
                    61: '陕西',
                    62: '甘肃',
                    63: '青海',
                    64: '宁夏',
                    65: '新疆',
                    71: '台湾',
                    81: '香港',
                    82: '澳门',
                    91: '国外',
                };
                if(!value){
                   callback(new Error('证件号码不能为空'));}
                if (
                    !value ||
                    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
                        value
                    )
                ) {
                    callback(new Error('身份证号格式错误'));
                } else if (!city[value.substr(0, 2)]) {
                    callback(new Error('地址编码错误'));
                } else {
                    if (value.length == 18) {
                        value = value.split('');
                        let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                        let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                        let sum = 0;
                        let ai = 0;
                        let wi = 0;
                        for (let i = 0; i < 17; i++) {
                            ai = value[i];
                            wi = factor[i];
                            sum += ai * wi;
                        }
                        if (parity[sum % 11] != value[17]) {
                            callback(new Error('校验位错误'));
                        } else {
                            await this.go(value.length)
                            return true, callback();
                        }
                    }
                }

            },
            init(id) {
                let _this = this
                this.dataForm.id = id
                this.visible = true
                this.$nextTick(() => {
                    this.getCredentials()
                    console.log('11111111111111111111')
                    this.$refs['dataForm'].resetFields()
                    this.useridList = []
                    this.fileList = []
                    this.approvers = []
                    this.equips = []
                    this.dataListSelections = []
                    if (this.dataForm.id) {
                        this.$http({
                            url: '/bjba/bmry/info/' + this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            _this.dataForm = data.data;
                            _this.fileList = JSON.parse(data.data.filesstr)
                            // this.dataForm.id    = data.data.id
                            // this.dataForm.id  = data.data.id
                            // this.dataForm.credentialId = data.data.credentialId
                            // this.dataForm.time = data.data.time
                            // var user = {id:data.data.userId,xm:data.data.xm}
                            // this.approvers.push(user)
                            // if (data.data.urls) {
                            //   let filelist = data.data.urls.map(e=>{
                            //     return {url:e}
                            //   })
                            //   this.fileList = filelist
                            // }
                        })
                    }
                })

            },

            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.dataForm.filesstr = JSON.stringify(this.fileList)
                        // this.dataForm.datils =
                        this.$http({
                            url: '/bjba/bmry/update',
                            method: 'post',
                            data: this.dataForm
                        }).then(({data}) => {
                            if (data && data.code === 200) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500
                                })
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else if (data && data.code === 500) {
                                this.$message({
                                    message: data.message,
                                    type: 'error',
                                    duration: 1500
                                })
                            }
                        })


                    }
                })
            },
            handlePictureCardPreview(file) {
                this.dialogVisible = true
                this.dialogImageUrl = file.url
            },
            handleRemove(file, fileList) {
                this.fileList.splice(this.fileList.findIndex(e => e.uid === file.uid), 1)
                if (file.url && !this.dataForm.id) {
                    this.$request({
                        method: 'post',
                        url: '/bjba/fileupload/delete',
                        params: {url: file.url}
                    }).then(res => {
                        console.log(res.data)
                    })
                }
            },
            httpRequest(data) {
                let _that = this;
                let rd = new FileReader(); // 创建文件读取对象
                let file = data.file;
                let formData = new FormData();
                formData.append('file', file);
                this.$request({
                    method: 'post',
                    url: '/bjba/fileupload/upload',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then(res => {
                    console.log(res.data)
                    this.fileList.push({url: res.data.url})
                })
            },
            getCredentials() {
                let that = this;
                this.$request.get('/bjba/credentials/findAll').then(res => {
                    this.credentials = res.data.data
                })
            },
            searchChecker1(query) {
                console.log(query)
                if (query !== '') {
                    this.loading1 = true;

                    this.$request.get('/bjba/yhgl/findUserListByxm', {
                        params: {
                            xm: query
                        }

                    }).then(res => {
                        this.loading1 = false
                        this.approvers = res.data.data

                    })
                } else {
                    this.approvers = [];
                }
            },
            // 实现自动生成生日，性别，年龄
            go(val) {
                let iden = this.dataForm.zjhm;
                let sex = null;
                let birth = null;
                let myDate = new Date();
                let month = myDate.getMonth() + 1;
                let day = myDate.getDate();
                let age = 0;

                if (val === 18) {
                    age = myDate.getFullYear() - iden.substring(6, 10) - 1;
                    sex = iden.substring(16, 17);
                    birth = iden.substring(6, 10) + "-" + iden.substring(10, 12) + "-" + iden.substring(12, 14);
                    if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;

                }
                if (val === 15) {
                    age = myDate.getFullYear() - iden.substring(6, 8) - 1901;
                    sex = iden.substring(13, 14);
                    birth = "19" + iden.substring(6, 8) + "-" + iden.substring(8, 10) + "-" + iden.substring(10, 12);
                    if (iden.substring(8, 10) < month || iden.substring(8, 10) == month && iden.substring(10, 12) <= day) age++;
                }

                if (sex % 2 === 0)
                    sex = '0';
                else
                    sex = '1';
                //性别  ==> 1:男       0:女
                // this.form.sex = sex;
                // this.form.age = age;
                debugger
                this.dataForm.nl = age;
                this.dataForm.xb = sex;
                this.dataForm.csrq = birth;
            },
        }
    }
</script>
